module.exports = __webpack_public_path__ + "img/image-3.c44d77f4.gif";